import { render, staticRenderFns } from "./ToolbarTemplate.vue?vue&type=template&id=1b64cff6&scoped=true&"
import script from "./ToolbarTemplate.vue?vue&type=script&lang=ts&"
export * from "./ToolbarTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ToolbarTemplate.vue?vue&type=style&index=0&id=1b64cff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b64cff6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBreadcrumbs,VSpacer,VToolbarTitle})
